// extracted by mini-css-extract-plugin
export default {"nil-tooltip":"style_nil-tooltip__UYVd7","nil-tooltip-text":"style_nil-tooltip-text__mtz2Y"};